<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" :back-level="1000" />
    <van-swipe class="fullAdRect" :autoplay="5000" indicator-color="white">
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <img v-lazy="image">
      </van-swipe-item>
    </van-swipe>
    <van-button type="primary" size="large" :color="GetColorMainBack()" @click="onGotoBuy">前往购买</van-button>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Swipe, SwipeItem, Lazyload } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Lazyload.name]: Lazyload,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: 'loading...',
      backurl: '/memberCard/memberCardList',
      typeId: undefined,
      data: undefined,
      loadingPage: true,
      images: []
      // https://res.diveboss.net/activity/20210415/1.jpg?x-oss-process=style/commodityicon
      // images: [
      //   'https://res.diveboss.net/activity/210401/ad0.jpg?x-oss-process=style/commodityicon',
      //   'https://res.diveboss.net/activity/210401/ad1.jpg?x-oss-process=style/commodityicon',
      //   'https://res.diveboss.net/activity/210401/ad2.jpg?x-oss-process=style/commodityicon',
      //   'https://res.diveboss.net/activity/210401/ad3.jpg?x-oss-process=style/commodityicon'
      // ]
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.typeId = this.$route.params.code
    this.init()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init() {
      this.loadingPage = true
      request({
        url: '/MemberCard/getMemberCardBuyInfoByType',
        method: 'post',
        params: { id: this.typeId }
      }).then(response => {
        this.loadingPage = false
        if (!response.success) {
          return
        }
        this.data = response.data
        this.title = this.data.type.name
        if (this.data.type.posterImgs) {
          this.images = this.data.type.posterImgs.split(',')
        }
      })
    },
    onGotoBuy() {
      this.$router.push('/memberCard/buy/0?typeid=' + this.data.type.cardTypeId)
    }
  }
}
</script>
<style scoped>
.fullAdRect{
  width: 100vw;
}
.fullAdRect img{
  width: 100vw;
}
</style>
